const initPageSlider = () => {
    const pageSlidersWidgetsArray = document.querySelectorAll(".pages-slider-widget");
    if (pageSlidersWidgetsArray && pageSlidersWidgetsArray.length > 0) {
        pageSlidersWidgetsArray.forEach((pageSliderWidget) => {
            const dataCarousel = pageSliderWidget.querySelector("[data-carousel]");
            if (dataCarousel) {
                const dataSlides = dataCarousel.querySelectorAll("[data-slide]");
                if (dataSlides && dataSlides.length > 2) {
                    initCarousel("[data-carousel]", cellAlign.left, true, false, false, null, 768);
                }
                else {
                    dataCarousel.setAttribute("data-carousel", "not-active");
                    pageSliderWidget.classList.add("not-slider");
                }
            }
        });
    }
};
